export default __webpack_public_path__ + "d32d984c0737015467c4d12e545cb570.svg";